export const PROPS_EMAIL_ADDRESS = "emailAddress";
export const PROPS_IS_PRIMARY = "isPrimary";
export const PROPS_EMAIL = "theEmail";
export const PROPS_COMPONENT_KEY = "personEmailList";
